<template>
<div>
 <div class="logo-title d-flex flex-row justify-content-between align-items-center">
      <div>
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'" @click="$router.push({name:'startPage'})">
        <div class="d-flex flex-column logo-col" style="padding-left:15px;">
          <h1 class="titleTop">Burger & Fries</h1>
          <h2 class="subTitleTop">Search or View Nearby Restaurants Below.</h2>
        </div>
      </div>
      <div>
        <button class="signIn d-flex align-items-center justify-content-around">
          <i class="fal fa-user-circle"></i>
          <span>Account</span>
        </button>
      </div>
    </div>
    <div class="mainreview d-flex flex-row" :style="cssProps">
        <div class="left d-flex flex-column">
            <div class="order-block d-flex flex-column align-items-center">
     
      <div class="container-property d-flex flex-column">
        <h1 class="title">Review & Place Order</h1>
        <h2 class="subTitle">Please review your order and place it.</h2>
 <!-- BEGIN BLOCK -->
        <div class="all-in d-flex flex-row justify-content-between">
          <div class="left-block d-flex flex-column align-items-center">
            <i class="fal fa-map-marker-alt"></i>
           
          </div>
          <div class="right-block d-flex flex-column" v-if="info.restaurant.id">
            <h1>{{info.restaurant.name}}</h1>
            <p>{{info.restaurant.streetaddress}}</p>
            <p>{{info.restaurant.city}}, {{info.restaurant.state}} {{info.restaurant.zip}}</p>
            <p>{{info.restaurant.telephone}}</p>
          </div>
          <div class="right-block d-flex flex-column" v-else>
            <h1>Restaurant</h1>
            <p>You haven't chosen restaurant yet.</p>
          </div>
          <div class="modify_link d-flex">
            <a href="#" @click="modifyAddress">Modify</a>
          </div>
          
          
        </div>
         <div class="all-in d-flex flex-row justify-content-between">
          <div class="left-block d-flex flex-column align-items-center">
            <i class="fal fa-truck"></i>
            
          </div>
          <div class="right-block d-flex flex-column" v-if="info.method && info.when">
              <h1>{{info.method.charAt(0).toUpperCase() + info.method.slice(1)}}</h1>
              <p>{{info.method.charAt(0).toUpperCase() + info.method.slice(1)}} {{info.when.charAt(0).toUpperCase() + info.when.slice(1)}}</p>
              <p v-if="info.deliveryDate">{{info.deliveryDate.dateName}}, {{info.deliveryDate.monthName}} {{info.deliveryDate.day}}</p>
              <p v-if="info.deliveryDate">{{info.deliveryDate.fullTime}}</p>
              <p v-if="info.when === 'asap'">{{asap}} minutes</p>
              <p v-if="info.savedDeliveryAddresses[info.choosedAddressIndex]">{{info.savedDeliveryAddresses[info.choosedAddressIndex].streetaddress}}, {{info.savedDeliveryAddresses[info.choosedAddressIndex].building}}</p>
              <p v-if="info.savedDeliveryAddresses[info.choosedAddressIndex]">{{info.savedDeliveryAddresses[info.choosedAddressIndex].city}} {{info.savedDeliveryAddresses[info.choosedAddressIndex].zipcode}}</p>
          </div>
          <div class="right-block d-flex flex-column" v-else>
                <h1>Schedule Order</h1>
                <p>Select a delivery time up to 7 days in advance.</p>
          </div>
          <div class="modify_link d-flex">
            <a href="#" v-if="info.method && info.when" @click="modifyDelivery">Modify</a>
          </div>
          
          
        </div>
    <!-- END BLOCK -->
   
        <div class="all-in d-flex flex-row justify-content-between">
          <div class="left-block d-flex flex-column align-items-center">
           <i class="fal fa-credit-card-front"></i>
            
          </div>
          <div class="right-block d-flex flex-column" v-if="info.paymentMethod">
            <h1>Payment Method</h1>
              <p v-if="info.paymentMethod === 'cash'">Cash</p>
              <div v-else>
              <p>Credit Card</p>
              <p>{{getCardInfo(info.savedCardDetails[info.choosedCardIndex].cardnumber).niceType}}</p>
              <div class="container-number d-flex flex-row justify-content-between" v-if="info.savedCardDetails[info.choosedCardIndex]">
                <div class="d-flex flex-row align-items-center">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                </div>
                <div class="d-flex flex-row align-items-center">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                </div>
                <div class="d-flex flex-row align-items-center">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <span class="lastnum">{{info.savedCardDetails[info.choosedCardIndex].cardnumber.slice(info.savedCardDetails[info.choosedCardIndex].cardnumber.length - 5, info.savedCardDetails[info.choosedCardIndex].cardnumber.length)}}</span>
                </div>
                </div>
            </div>
          </div>
          <div class="right-block d-flex flex-column" v-else>
            <h1>Payment Method</h1>
            <p>Select a valid payment method to continue.</p>
            
          </div>
          <div class="modify_link d-flex" v-if="info.paymentMethod">
            <a href="#" @click="modifyCard">Modify</a>
          </div>
          
          
        </div>
        <!-- <div class="all-in d-flex flex-row">
          <div class="left-block d-flex flex-column align-items-center">
           <i class="fal fa-home"></i>
            <div class="line-icon"> </div>
          </div>
          <div class="right-block d-flex flex-column">
            <h1>Delivery Address</h1>
            <p>Select a valid payment method to continue.</p>
            
          </div>
          <div class="modify_link d-flex">
            <a href="#" @click="modifyAddress">Modify</a>
          </div>
          
          
        </div> -->
       
      </div>
    </div>
        </div>
        <div class="center d-flex flex-column">
            <h1 class="title">Basket</h1>
            <h2 class="subTitle">Modify or add more products.</h2>
            <!-- <h3>YOU HAVE 3 PRODUCTS</h3> -->
            <div class="product d-flex flex-row justify-content-between" v-for="(product, index) in info.products" :key="index">
                <span>{{product.quantity}}</span>
                <div class="product-column d-flex flex-column">
                    <p>{{product.product.name}}</p>
                    <p>Single, Ketchup, Mayo, Steak Sauce</p>
                </div>
                <div class="product-info d-flex flex-row justify-content-between"> 
                    <i class="fal fa-trash"></i>
                    <p>${{product.product.cost}}</p>
                </div>
            </div>
             <div class="container-button d-flex flex-row align-items-center">
            <button type="button" class="btn-cont" >
                <span>Add More</span>
            </button>
             <div class="modify_linkdown d-flex" >
            <a href="#">Empty Basket</a>
            </div>
        </div>


        </div>
        <div class="right d-flex flex-column">
            <div class="d-flex flex-row justify-content-between">
                <div class="left-content d-flex flex-column">
                    <span>Items Subtotal:</span>
                    <span v-if="info.method">{{info.method.charAt(0).toUpperCase() + info.method.slice(1)}}</span>
                    <span>Tax</span>
                     <tips class="d-flex flex-row justify-content-between customTips ">
                      <span>Tips</span>  <b>20%</b> <a href="#" @click="modalTips">Modify</a>
                     </tips>
                     <span>Coupon Code?</span>
            
          
          
                   
                    
                </div>
                <div class="right-content d-flex flex-column">
                    <span>${{info.sum}}</span>
                    <span v-if="info.method">$0.00</span>
                    <span>$0.00</span>
                    <span>$3.47</span>
                    <span @click="choiceModal">Redeem Code</span>
                </div>
             
            </div>
            <div class="total d-flex flex-row justify-content-between">
                <h1>Total</h1>
                <h1>${{info.sum}}</h1>
            </div>
            <div class="button d-flex justify-content-center align-items-center">
                <button>Place Order</button>
            </div>
        </div>
    </div>
    <tipsModal ref="tipsModal"></tipsModal>
    <choice ref="choice"></choice>
</div>

</template>
<script>
import { mapState } from "vuex";
import firebase from '@/firebase/init';
import creditCardType from 'credit-card-type';
import tips from './modals/tips.vue';
import choiceModal from './modals/choiceModal.vue';
export default {
    name: 'review',
     components: {
       tipsModal:tips,
       choice:choiceModal
     },
    data(){
        return{
        }
    },
    computed: {
         ...mapState(["info"]),
         asap: function(){
            // let today = new Date();
            // let tmp = this.info.basket.earliestreadytime;
            // tmp = tmp.slice(0, 4) + "/" + tmp.slice(4, 6) + "/" + tmp.slice(6, 8) + " " + tmp.slice(9) + ":00";
            // var diff = Math.abs(new Date() - new Date(tmp));
            // return Math.floor(diff / 1000 / 60);
            return '10-20'
        },
        cssProps() { return {
            '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
        }
      }
    },
    methods: {
      modalTips()
        {
            this.$refs.tipsModal.show()
        },
        choiceModal()
        {
             this.$refs.choice.show()
        },
     
    },
    
}
</script>
<style scoped>
.customTips{
  padding-top: 40px;
}
.customTips b{

	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 36px;
}
.customTips a{
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
	line-height: 36px;
  text-align: right;
  text-decoration: underline;
}
.total {
  padding-top: 40px;
}
.total h1{

	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 18px;
	font-weight: 800;
	line-height: 27px;

}

.predescription i
{
 
	opacity: 0.4;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 13px;
	line-height: 13px;
}
.predescription span:last-child
{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.predescription .preTitle
{
 
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 15px;
  text-decoration: underline;
}
.predescription .preInfo{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;

}
.predescription .count
{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: left;
  padding-right: 10px;

}
/* .predescription
{
  width: 250px !important;
} */

/* .predescription div p
{
  width: 130px !important;
} */
/* .container-property .all-in:nth-child(2)
{
  padding-top: 33px;
} */
.container-property .all-in
{
  padding-top: 32px;
}


/* .left-block {
  width: 20%;
} */
.left-block i {
  height: 21px;
  width: 28px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
}
.line-icon
{
	box-sizing: border-box;
	height: 82px;
	width: 1px;
	border: 1px solid #000000;
	opacity: 0.1;
  margin-top: 8px;
}
.right-block {
     width: 100%;
    padding-left: 35px;
}

.right-block h1 {
  /* height: 32px; */
  width: 155px;
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
  /* margin-bottom: 25px; */
}



.right-block p {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin: 0 ;
  width: 200px;
}
.container-property .all-in:nth-child(3) .right-block h1{
margin-bottom: 8px;
}
.modify_link {
  width: 15% !important ;
  padding: 0 !important;
  /* padding-left: 10%; */
}
.modify_link a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
}
.container-property {
  width: 100%;
  
}
.titleTop {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 26px;
  color: #000000;
  text-align: left;
}
.subTitleTop {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  /* line-height: 20px; */
  color: #000000;
  text-align: left;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.logo-title {
  padding: 15px 25px;
  border: 1.5px solid rgba(0, 0, 0, 0.05);
}

.logo-title img {
  width: 50px;
  height: 50px;
  float: left;
  border-radius: 15px;
}

.left{
  /* width: 480px; */
width:33%;
   border-right: 1.5px solid rgba(0, 0, 0, 0.05);
   padding: 33px;
}
.button
{
  width:100%;
    padding-top: 48px;
}
.button button{

	height: 55px;
	width: 384px;
	border-radius: 27.5px;
   font-family: Poppins;
    font-weight: bold;
    font-size: 16px;
	background-color: var(--main-color);
    color:white;

}


.left-content span
{

	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 36px;

}
.left-content span:last-child{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 36px;
}



.right-content span
{
    
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 36px;
  text-align: right
}
.right-content span:last-child{
  text-decoration: underline;
  font-size: 16px;
  cursor: pointer;
}
.right-content span:nth-child(4){
  padding-top: 42px;
}
/* .right-content span:last-child{
  padding-top: 42px;
} */


button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.btn-cont
{
   
	height: 48px;
	width: 201px;
	border-radius: 24px;
	/* background-color: rgba(0,0,0,0.6); */
background-color: #FFFFFF;
border: 1px solid var(--main-color);
}
.btn-cont span{
  
	/* color: #FFFFFF; */
    color:var(--main-color);
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.modify_linkdown {
  width: 10%;
  padding-left: 10%;
}
.modify_linkdown a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
    white-space: nowrap;
}
.link_clear{
    padding-left: 10%;
}
.link_clear a{
    opacity: 0.4;
    color: #000000;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 25px;
    text-align: right;
    text-decoration: underline;
    white-space: nowrap;
    padding-top: 48px;
}
.container-button
{
    padding-top: 48px;
    width: 100%;
    padding-left: 48px;
}
.product-info
{
    width: 100px;
}
.product-info i{
  
	height: 16px;
	width: 16px;
	opacity: 0.3;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 16px;
	line-height: 22px;
	text-align: right;
}
.product-info p{
    
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: 500;
	line-height: 25px;
	text-align: right;

}
.product-column p:first-child
{
  
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 23px;
    text-decoration: underline;
    width: 180px;
}
.product-column p:last-child
{
    
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
    width: 180px; 
}

.product
{
    padding-top: 32px;
}
.product span
{
   
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: 300;
	line-height: 23px;
	text-align: center;
}
.product span::before
{
    content: "-";
   
	height: 28px;
	width: 10px;
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: 300;
	line-height: 23px;
    padding-right: 8px;
}

.product span::after
{
    content: "+";
   padding-left: 8px;
	height: 28px;
	width: 12px;
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: 300;
	line-height: 23px;
}

.right
{
    width: 33%;
     /* width: 480px; */
         padding: 33px;

}
.center
{
    padding: 33px;
    /* width: 480px; */
    width: 33%;
    border-right: 1.5px solid rgba(0, 0, 0, 0.05);
}
.center h3
{
   
    padding-top: 48px;
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;

}

.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 35px;
  color: #000000;
  text-align: left;
}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  line-height: 20px;
  color: #000000;
  text-align: left;
  white-space: nowrap
}
.container-number {
  width: 50%;
}
.lastnum {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 5px;
}
.dot {
  -moz-border-radius: 50px/50px;
  -webkit-border-radius: 50px 50px;
  border-radius: 50px/50px;
  border: 2px solid rgba(0, 0, 0, 0.6);
  background-color: #ffffff;
  width: 5px;
  height: 5px;
  margin-left: 1px;
  opacity: 0.6;
}
@media screen and (max-width: 600px)
{
    .mainreview
    {
        flex-direction: column !important;
    }
    .center{
        width: 100%;
    }
    .right{
        width: 100%;
    }
    .button 
    {
        margin-bottom: 45px;
    }
    .container-button
    {
        padding-left: 0px !important;
    }
    .product
    {
        width: 100%;
    }
    .product-column p
    {
        padding-left: 10px;
    }
    .product-info
    {
        justify-content: space-around !important;
    }
    .left{
        width: 100%;
    }
}

</style>







// WEBPACK FOOTER //
// src/components/steps/review.vue